import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { getAPIBaseURL } from '../services/helpers'
import { getData } from '../services/request'

const JobSeekerVerifyEmail = () => {
  const { userId, token } = useParams()
  const [status, setStatus] = useState({ loading: true, success: false, message: '' })

  useEffect(() => {
    const verify = async () => {
      if (!userId || !token) {
        setStatus({ loading: false, success: false, message: 'Invalid verification link' })
        return
      }

      const url = `${getAPIBaseURL()}/employme/auth/verify-email/${userId}/${token}`
      const res = await getData(url, {}, {})

      if (!res || res.error) {
        setStatus({
          loading: false,
          success: false,
          message: res?.result?.data?.data || 'Verification failed'
        })
        return
      }

      if (res.result.status === 200) {
        setStatus({
          loading: false,
          success: true,
          message: res.result.data?.data || 'Email verified successfully'
        })
      } else {
        setStatus({
          loading: false,
          success: false,
          message: res.result.data?.data || 'Verification failed'
        })
      }
    }

    verify()
  }, [userId, token])

  return (
    <div className="px-4 py-10">
      <div className="mx-auto max-w-md rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <h1 className="text-xl font-semibold text-slate-900">Verify your email</h1>
        <p className="mt-1 text-sm text-slate-600">
          We are confirming your email address for your Employ Me account.
        </p>
        <div className="mt-5">
          {status.loading ? (
            <div className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-sm text-slate-600">
              Verifying your email...
            </div>
          ) : status.success ? (
            <div className="rounded-lg border border-green-200 bg-green-50 p-3 text-sm font-medium text-green-700">
              {status.message || 'Email verified successfully'}
            </div>
          ) : (
            <div className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm font-medium text-red-700">
              {status.message || 'Verification failed'}
            </div>
          )}
        </div>

        {!status.loading && (
          <div className="mt-6 text-center">
            <Link
              to="/login"
              className="inline-flex items-center justify-center rounded-lg bg-[#00A5E6] px-5 py-2.5 text-sm font-medium text-white hover:bg-[#008FCC] focus:outline-none focus:ring-4 focus:ring-[#cceffd]"
            >
              Proceed to login
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default JobSeekerVerifyEmail

